module.exports = __webpack_public_path__ + "img/bg_resize_castle_mist.9268cf81.webp";